export type tTheme = 'dark' | 'light';
export const DEFAULT_THEME: tTheme = 'dark';
